import {
  ComponentRegister,
  ComponentRegisters,
} from '@agilelab/plugin-wb-platform-common';
import { ReactElement } from 'react';

export enum CustomViewPageCategory {
  MARKETPLACE = 'MARKETPLACE',
  BUILDER = 'BUILDER',
  PRACTICE_SHAPER = 'PRACTICE_SHAPER',
}

export enum CustomViewTypeIdType {
  SYSTEM_TYPE = 'SYSTEM_TYPE',
  COMPONENT_TYPE = 'COMPONENT_TYPE',
  SYSTEM_PROTOTYPE = 'SYSTEM_PROTOTYPE_TYPE',
}

export enum CustomViewTemplateIdType {
  SYSTEM_TYPE = 'SYSTEM_TYPE',
  COMPONENT_TYPE = 'COMPONENT_TYPE',
}

type CustomViewPreviewItem = {
  src: string;
};

export type CustomViewPageMeta = {
  label: string;
  category: CustomViewPageCategory;
  typeId?: {
    type?: CustomViewTypeIdType;
  };
  templateId?: {
    type?: CustomViewTemplateIdType;
  };
  preview: {
    thumbnail: {
      src: string;
    };
    // typed like this to enforce the array containing atleat one item
    items: [CustomViewPreviewItem, ...CustomViewPreviewItem[]];
  };
};

type PageEntry = {
  id: string;
  meta: CustomViewPageMeta;
  data?: ReactElement;
};

class CustomViewPagesRegister {
  private registry: ComponentRegister<ReactElement>;
  constructor() {
    this.registry =
      ComponentRegisters.getComponentRegister<ReactElement>('customPages');
  }
  exists(pageId: string): boolean {
    return this.registry.exists(pageId);
  }
  get(pageId: string): ReactElement | undefined {
    return this.registry.get(pageId);
  }
  getMetadata(pageId: string): CustomViewPageMeta | undefined {
    return this.registry.getMetadata(pageId) as CustomViewPageMeta;
  }
  register(entry: PageEntry): void {
    this.registry.register({
      id: entry.id,
      metadata: entry.meta,
      data: entry.data,
    });
  }
  getAll() {
    return this.registry.listIds();
  }
}

export const CustomViewPages = new CustomViewPagesRegister();
